import React from 'react';
import { isMobileScreen } from '@apply/ui';
import { TabPanel, Tab, TabPanelTheme, TabButtonStyle, TabPanelBorderRadius } from '@apply/components';
import { ByPropertyPanel } from './components/ByPropertyPanel/ByPropertyPanel';
import { ByUserPanel } from './components/ByUserPanel/ByUserPanel';
import { InviteUserButton } from '../InviteUserButton/InviteUserButton';
import { useRefreshUserManagement } from '../../../manageusers/queries/userManagementQueries';

export interface UserManagementSectionTabPanelProps {
    activeIndex: number;
    set_selectedTab: (index: number) => void;
}

export const UserManagementSectionTabPanel: React.FC<UserManagementSectionTabPanelProps> = ({ activeIndex, set_selectedTab }) => {
    const mobileScreen = isMobileScreen();
    const handleRefresh = useRefreshUserManagement();

    return (
        <>
            <TabPanel
                id='userManagementSectionTabPanel'
                theme={TabPanelTheme.Blue}
                width='100%'
                tabButtonStyle={mobileScreen ? TabButtonStyle.Fill : TabButtonStyle.Condensed}
                tabPanelBorderRadius={mobileScreen ? TabPanelBorderRadius.None : TabPanelBorderRadius.Medium}
                activeIndex={activeIndex}
                onTabChange={set_selectedTab}
            >
                <Tab
                    id='byPropertyTab'
                    text='By Property'
                    key='tabItem_byPropertyTab'
                >
                    {mobileScreen && (
                        <div className='manageUsers-sectionTabPanel-inviteUser'>
                            <InviteUserButton onRefresh={handleRefresh} />
                        </div>
                    )}
                    <ByPropertyPanel />
                </Tab>
                <Tab
                    id='byUserTab'
                    text='By User'
                    key='tabItem_byUserTab'
                >
                    {mobileScreen && (
                        <div className='manageUsers-sectionTabPanel-inviteUser'>
                            <InviteUserButton onRefresh={handleRefresh} />
                        </div>
                    )}
                    <ByUserPanel />
                </Tab>
            </TabPanel>
        </>
    );
};
